import React, { useCallback } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PublicPage from "../../PublicPage";
import TransactionHeader from "./TransactionHeader";
import SellerFlowTrack from "./SellerFlowTrack";
import DealPurchaseClosing from "./insurance/DealPurchaseClosing";
import { OWNERSHIP_TRACK } from "./ownership/DealOwnershipStage";

// "Köpet är genomfört" — the buyer's closing page, after Försäkra bilen.
//
// A DEMO page: hard-coded in the front end, no API call, nothing saved. What the buyer did about
// insurance arrives in the router state from the previous page; after a reload this browser holds
// nothing and the insurance row is simply left out. As with the seller's closing page, this is NOT
// a deal-flow path (lib/dealSession): the deal is finished, so there is nothing to leave.
export default function DealPurchaseCompletionPage() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const go = useCallback((to) => navigate(to), [navigate]);

  return (
    <PublicPage>
      <div className="flex min-h-screen flex-col bg-ds-canvas">
        <TransactionHeader />
        <main className="ds-scope w-full flex-1 px-4 pb-16 pt-6 md:px-6">
          <div className="ds-form mx-auto w-full">
            <div className="flow-shell-track">
              <SellerFlowTrack terminal activeStep={0} t={t} milestones={OWNERSHIP_TRACK} ns="buyer" />
            </div>
            <DealPurchaseClosing
              insurance={state?.insurance || null}
              onNavigate={go}
              recordPath={`/affarshistorik/${id}`}
              vehiclesPath="/fordon"
            />
          </div>
        </main>
      </div>
    </PublicPage>
  );
}
